import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { AuthGuardData, createAuthGuard } from 'keycloak-angular'
import { inject } from '@angular/core'
import Keycloak from 'keycloak-js'

export const AuthGuard = async (
	route: ActivatedRouteSnapshot,
	_: RouterStateSnapshot,
	authData: AuthGuardData
): Promise<boolean | UrlTree> => {
	const { authenticated } = authData
	if (authenticated) {
		return authenticated
	}

	const router = inject(Router)
	return router.parseUrl('/')
}

export const isAuthenticated = createAuthGuard<CanActivateFn>(AuthGuard)

export const redirectToDashboardIfAuthenticated: CanActivateFn = () => {
	const keycloak = inject(Keycloak)
	const router = inject(Router)
	if (keycloak.authenticated) {
		return router.parseUrl('/dashboard')
	}
	return true
}
